import { populate } from "populate";

const raw = {
  handleResize: true,
  width: 0,
  height: 0,
  x: 0,
  y: 0,
  list: [
    {
      id: "1",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "2",
      type: "Container",
      name: "backgrounds",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "1",
      data: ""
    },
    {
      id: "3",
      type: "Container",
      name: "nodesContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "1",
      data: ""
    },
    {
      id: "4",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "1",
      data: ""
    },
    {
      id: "5",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "1",
      data: ""
    },
    {
      id: "6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world15_1",
      parent: "2",
      data: ""
    },
    {
      id: "7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2702,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world15_2",
      parent: "2",
      data: ""
    },
    {
      id: "8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5404,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world15_3",
      parent: "2",
      data: ""
    },
    {
      id: "9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8106,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world15_4",
      parent: "2",
      data: ""
    },
    {
      id: "10",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 218,
      y: 457,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "11",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 324,
      y: 432,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "12",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 420,
      y: 390,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "13",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 515,
      y: 347,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "14",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 617,
      y: 326,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "15",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 722,
      y: 330,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "16",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 812,
      y: 378,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "17",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 874,
      y: 452,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "18",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 936,
      y: 523,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "19",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1042,
      y: 531,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "20",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1133,
      y: 486,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "21",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1218,
      y: 432,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "22",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1295,
      y: 370,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "23",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1374,
      y: 309,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "24",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1465,
      y: 258,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "25",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1571,
      y: 229,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "26",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1673,
      y: 245,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "27",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1755,
      y: 299,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "28",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1809,
      y: 374,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "29",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1845,
      y: 461,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "30",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1888,
      y: 540,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "31",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1975,
      y: 585,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "32",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2081,
      y: 583,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "33",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2168,
      y: 527,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "34",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2239,
      y: 457,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "35",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2311,
      y: 390,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "36",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2390,
      y: 338,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "37",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2492,
      y: 300,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "38",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2585,
      y: 333,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "39",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2647,
      y: 404,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "40",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2747,
      y: 453,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "41",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2847,
      y: 508,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "42",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2946,
      y: 559,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "43",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3066,
      y: 550,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "44",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3162,
      y: 488,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "45",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3246,
      y: 420,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "46",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3337,
      y: 355,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "47",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3427,
      y: 289,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "48",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3520,
      y: 227,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "49",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3627,
      y: 191,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "50",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3744,
      y: 194,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "51",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3846,
      y: 238,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "52",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3919,
      y: 307,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "53",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3981,
      y: 391,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "54",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4039,
      y: 475,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "55",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4114,
      y: 548,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "56",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4225,
      y: 573,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "57",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4303,
      y: 500,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "58",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4362,
      y: 415,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "59",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4429,
      y: 335,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "60",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4530,
      y: 280,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "61",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4647,
      y: 266,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "62",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4755,
      y: 308,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "63",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4844,
      y: 368,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "64",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4910,
      y: 450,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "65",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4976,
      y: 524,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "66",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5078,
      y: 557,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "67",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5160,
      y: 499,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "68",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5213,
      y: 416,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "69",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5297,
      y: 360,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "70",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5394,
      y: 404,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "71",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5507,
      y: 412,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "72",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5624,
      y: 400,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "73",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5728,
      y: 355,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "74",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5815,
      y: 292,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "75",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5897,
      y: 231,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "76",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5991,
      y: 186,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "77",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6094,
      y: 212,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "78",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6157,
      y: 289,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "79",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6213,
      y: 371,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "80",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6279,
      y: 448,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "81",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6363,
      y: 509,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "82",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6471,
      y: 537,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "83",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6581,
      y: 521,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "84",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6682,
      y: 479,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "85",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6786,
      y: 440,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "86",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6884,
      y: 390,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "87",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6983,
      y: 336,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "88",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7071,
      y: 273,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "89",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7163,
      y: 215,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "90",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7280,
      y: 197,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "91",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7383,
      y: 238,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "92",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7472,
      y: 298,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "93",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7544,
      y: 367,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "94",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7597,
      y: 448,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "95",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7645,
      y: 528,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "96",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7730,
      y: 584,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "97",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7836,
      y: 552,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "98",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7925,
      y: 498,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "99",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8009,
      y: 442,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "100",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8082,
      y: 370,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "101",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8171,
      y: 310,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "102",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8273,
      y: 264,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "103",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8382,
      y: 242,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "104",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8489,
      y: 209,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "105",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8599,
      y: 184,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "106",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8712,
      y: 176,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "107",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8823,
      y: 197,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "108",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8916,
      y: 253,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "109",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8968,
      y: 336,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "110",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9004,
      y: 425,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "111",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9093,
      y: 476,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "112",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9207,
      y: 458,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "113",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9305,
      y: 411,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "114",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9388,
      y: 342,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "115",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9489,
      y: 296,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "116",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9586,
      y: 344,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "117",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9646,
      y: 421,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "118",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9704,
      y: 503,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "119",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9781,
      y: 568,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "120",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9886,
      y: 583,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "121",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9988,
      y: 547,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "122",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10064,
      y: 481,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "123",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10109,
      y: 400,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "124",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10154,
      y: 318,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "125",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10257,
      y: 291,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "126",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10325,
      y: 361,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "127",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10392,
      y: 432,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "128",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10483,
      y: 482,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "129",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10593,
      y: 482,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "130",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "140",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "150",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "179",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "197",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "208",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "218",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "237",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "136",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "146",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "175",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "193",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "204",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "214",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "233",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "249",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "131",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 962,
      y: 323,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "manuka_3",
      parent: "130",
      data: ""
    },
    {
      id: "132",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1183,
      y: 245,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "manuka_3",
      parent: "130",
      data: ""
    },
    {
      id: "133",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 700,
      y: 585,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "manuka_3",
      parent: "130",
      data: ""
    },
    {
      id: "134",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 503,
      y: 685,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "manuka_3",
      parent: "130",
      data: ""
    },
    {
      id: "135",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1481,
      y: 561,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "manuka_3",
      parent: "130",
      data: ""
    },
    {
      id: "141",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1735,
      y: 704,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "manuka_3",
      parent: "140",
      data: ""
    },
    {
      id: "142",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2043,
      y: 464,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "manuka_3",
      parent: "140",
      data: ""
    },
    {
      id: "143",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1947,
      y: 239,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "manuka_3",
      parent: "140",
      data: ""
    },
    {
      id: "144",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2250,
      y: 298,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "manuka_3",
      parent: "140",
      data: ""
    },
    {
      id: "145",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2460,
      y: 599,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "manuka_3",
      parent: "140",
      data: ""
    },
    {
      id: "151",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3168,
      y: 777,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "150",
      data: ""
    },
    {
      id: "152",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3297,
      y: 673,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "150",
      data: ""
    },
    {
      id: "153",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3289,
      y: 881,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "150",
      data: ""
    },
    {
      id: "154",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3433,
      y: 573,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "150",
      data: ""
    },
    {
      id: "155",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3569,
      y: 486,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "150",
      data: ""
    },
    {
      id: "156",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3707,
      y: 442,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "150",
      data: ""
    },
    {
      id: "157",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3423,
      y: 774,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "150",
      data: ""
    },
    {
      id: "158",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3560,
      y: 688,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "150",
      data: ""
    },
    {
      id: "159",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3548,
      y: 897,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "150",
      data: ""
    },
    {
      id: "160",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3836,
      y: 544,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "150",
      data: ""
    },
    {
      id: "161",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3955,
      y: 697,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "150",
      data: ""
    },
    {
      id: "162",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3697,
      y: 647,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "150",
      data: ""
    },
    {
      id: "163",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3823,
      y: 743,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "150",
      data: ""
    },
    {
      id: "164",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3946,
      y: 895,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "150",
      data: ""
    },
    {
      id: "165",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3355,
      y: 97,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "150",
      data: ""
    },
    {
      id: "166",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3487,
      y: 151,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "150",
      data: ""
    },
    {
      id: "167",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3626,
      y: 98,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "150",
      data: ""
    },
    {
      id: "168",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3757,
      y: 60,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "150",
      data: ""
    },
    {
      id: "169",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3894,
      y: 122,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "150",
      data: ""
    },
    {
      id: "170",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4022,
      y: 232,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "150",
      data: ""
    },
    {
      id: "171",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4164,
      y: 331,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "150",
      data: ""
    },
    {
      id: "172",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4182,
      y: 133,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "150",
      data: ""
    },
    {
      id: "173",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4043,
      y: 38,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "150",
      data: ""
    },
    {
      id: "174",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3686,
      y: 845,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "150",
      data: ""
    },
    {
      id: "180",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4423,
      y: 654,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "179",
      data: ""
    },
    {
      id: "181",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4554,
      y: 539,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "179",
      data: ""
    },
    {
      id: "182",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4690,
      y: 570,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "179",
      data: ""
    },
    {
      id: "183",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4811,
      y: 651,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "179",
      data: ""
    },
    {
      id: "184",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4438,
      y: 867,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "179",
      data: ""
    },
    {
      id: "185",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4857,
      y: 867,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "179",
      data: ""
    },
    {
      id: "186",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4684,
      y: 781,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "179",
      data: ""
    },
    {
      id: "187",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4502,
      y: 58,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "179",
      data: ""
    },
    {
      id: "188",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4631,
      y: 144,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "179",
      data: ""
    },
    {
      id: "189",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4767,
      y: 188,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "179",
      data: ""
    },
    {
      id: "190",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4903,
      y: 142,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "179",
      data: ""
    },
    {
      id: "191",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4550,
      y: 737,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "179",
      data: ""
    },
    {
      id: "192",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4300,
      y: 809,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_4",
      parent: "179",
      data: ""
    },
    {
      id: "198",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5785,
      y: 650,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "kowhai_3",
      parent: "197",
      data: ""
    },
    {
      id: "199",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5993,
      y: 530,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "kowhai_3",
      parent: "197",
      data: ""
    },
    {
      id: "200",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6183,
      y: 735,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "kowhai_3",
      parent: "197",
      data: ""
    },
    {
      id: "201",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6276,
      y: 214,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "kowhai_3",
      parent: "197",
      data: ""
    },
    {
      id: "202",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6500,
      y: 392,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "kowhai_3",
      parent: "197",
      data: ""
    },
    {
      id: "203",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6903,
      y: 227,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "kowhai_3",
      parent: "197",
      data: ""
    },
    {
      id: "209",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6964,
      y: 678,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "kowhai_3",
      parent: "208",
      data: ""
    },
    {
      id: "210",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7244,
      y: 530,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "kowhai_3",
      parent: "208",
      data: ""
    },
    {
      id: "211",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7394,
      y: 735,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "kowhai_3",
      parent: "208",
      data: ""
    },
    {
      id: "212",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7767,
      y: 440,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "kowhai_3",
      parent: "208",
      data: ""
    },
    {
      id: "213",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8032,
      y: 761,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "kowhai_3",
      parent: "208",
      data: ""
    },
    {
      id: "219",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8825,
      y: 43,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "boysenberry_4",
      parent: "218",
      data: ""
    },
    {
      id: "220",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9157,
      y: 128,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "boysenberry_4",
      parent: "218",
      data: ""
    },
    {
      id: "221",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9036,
      y: 35,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "boysenberry_4",
      parent: "218",
      data: ""
    },
    {
      id: "222",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8937,
      y: 129,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "boysenberry_4",
      parent: "218",
      data: ""
    },
    {
      id: "223",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9062,
      y: 214,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "boysenberry_4",
      parent: "218",
      data: ""
    },
    {
      id: "224",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9249,
      y: 168,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "boysenberry_4",
      parent: "218",
      data: ""
    },
    {
      id: "225",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9069,
      y: 747,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "boysenberry_4",
      parent: "218",
      data: ""
    },
    {
      id: "226",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9434,
      y: 615,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "boysenberry_4",
      parent: "218",
      data: ""
    },
    {
      id: "227",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9345,
      y: 747,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "boysenberry_4",
      parent: "218",
      data: ""
    },
    {
      id: "228",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9189,
      y: 708,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "boysenberry_4",
      parent: "218",
      data: ""
    },
    {
      id: "229",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8914,
      y: 655,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "boysenberry_4",
      parent: "218",
      data: ""
    },
    {
      id: "230",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9672,
      y: 730,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "boysenberry_4",
      parent: "218",
      data: ""
    },
    {
      id: "231",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9533,
      y: 742,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "boysenberry_4",
      parent: "218",
      data: ""
    },
    {
      id: "232",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8875,
      y: 779,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "boysenberry_4",
      parent: "218",
      data: ""
    },
    {
      id: "238",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9569,
      y: 99,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "boysenberry_4",
      parent: "237",
      data: ""
    },
    {
      id: "239",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9762,
      y: 101,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "boysenberry_4",
      parent: "237",
      data: ""
    },
    {
      id: "240",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9908,
      y: 140,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "boysenberry_4",
      parent: "237",
      data: ""
    },
    {
      id: "241",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9680,
      y: 218,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "boysenberry_4",
      parent: "237",
      data: ""
    },
    {
      id: "242",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9830,
      y: 302,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "boysenberry_4",
      parent: "237",
      data: ""
    },
    {
      id: "243",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10087,
      y: 146,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "boysenberry_4",
      parent: "237",
      data: ""
    },
    {
      id: "244",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9993,
      y: 230,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "boysenberry_4",
      parent: "237",
      data: ""
    },
    {
      id: "245",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10229,
      y: 626,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "boysenberry_4",
      parent: "237",
      data: ""
    },
    {
      id: "246",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10092,
      y: 739,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "boysenberry_4",
      parent: "237",
      data: ""
    },
    {
      id: "247",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10284,
      y: 765,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "boysenberry_4",
      parent: "237",
      data: ""
    },
    {
      id: "248",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10398,
      y: 700,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "boysenberry_4",
      parent: "237",
      data: ""
    },
    {
      id: "137",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1106,
      y: 306,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "136",
      data: ""
    },
    {
      id: "147",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2076,
      y: 270,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "146",
      data: ""
    },
    {
      id: "176",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3653,
      y: 436,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "175",
      data: ""
    },
    {
      id: "194",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4626,
      y: 524,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "193",
      data: ""
    },
    {
      id: "205",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5956,
      y: 357,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "204",
      data: ""
    },
    {
      id: "215",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7244,
      y: 346,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "214",
      data: ""
    },
    {
      id: "234",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9105,
      y: 124,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "233",
      data: ""
    },
    {
      id: "250",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10250,
      y: 609,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "249",
      data: ""
    },
    {
      id: "138",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "137",
      data: ""
    },
    {
      id: "139",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "manuka_harvest_map",
      parent: "137",
      data: ""
    },
    {
      id: "148",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "147",
      data: ""
    },
    {
      id: "149",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "manuka_harvest_map",
      parent: "147",
      data: ""
    },
    {
      id: "177",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "176",
      data: ""
    },
    {
      id: "178",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_harvest_map",
      parent: "176",
      data: ""
    },
    {
      id: "195",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "194",
      data: ""
    },
    {
      id: "196",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "lupine_harvest_map",
      parent: "194",
      data: ""
    },
    {
      id: "206",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 20,
      y: 25,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 180,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "205",
      data: ""
    },
    {
      id: "207",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "kowhai_harvest_map",
      parent: "205",
      data: ""
    },
    {
      id: "216",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 20,
      y: 25,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 180,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "215",
      data: ""
    },
    {
      id: "217",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "kowhai_harvest_map",
      parent: "215",
      data: ""
    },
    {
      id: "235",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 20,
      y: 25,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 180,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "234",
      data: ""
    },
    {
      id: "236",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "boysenberry_harvest_map",
      parent: "234",
      data: ""
    },
    {
      id: "251",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "250",
      data: ""
    },
    {
      id: "252",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "boysenberry_harvest_map",
      parent: "250",
      data: ""
    }
  ]
} as const;

export class WorldLayout15 {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  backgrounds: GameObject<PIXI.Container>;
  nodesContainer: GameObject<PIXI.Container>;
  cropsSectorA: (GameObject<PIXI.Container>)[];
  cropsSectorB: (GameObject<PIXI.Container>)[];
  signsSectorA: (GameObject<PIXI.Container>)[];
  signsSectorB: (GameObject<PIXI.Container>)[];

  constructor() {
    populate(this, raw);
  }
}
